import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { useAuth } from 'Pages/PrivateRoute/AuthContext';

const PrivateRoute: React.FC = () => {
  const { isAuthenticated } = useAuth();

  // Redirect to login if not authenticated
  return isAuthenticated ? <Outlet /> : <Navigate to="/" />;
};

export default PrivateRoute;
